// SPDX-License-Identifier: AGPL-3.0-or-later

import {MenuGroupLabel, MenuGroup as MenuGroupPrimitive, MenuSeparator} from '@app/features/ui/action_menu/ContextMenu';
import {observer} from 'mobx-react-lite';
import React from 'react';

interface MenuGroupProps {
	children?: React.ReactNode;
	/** A section of its own (Konvo, ClickUp…): its logo and name head the card. */
	title?: string;
	titleIcon?: React.ReactNode;
}

export const MenuGroup: React.FC<MenuGroupProps> = observer(({children, title, titleIcon}) => {
	const validChildren = React.Children.toArray(children).filter((child): child is React.ReactElement => {
		if (!React.isValidElement(child)) return false;
		if (child.type === React.Fragment && !(child.props as {children?: React.ReactNode}).children) return false;
		return true;
	});
	if (validChildren.length === 0) {
		return null;
	}
	return (
		<>
			<MenuGroupPrimitive data-flx="ui.action-menu.menu-group.menu-group-primitive">
				{title ? (
					<MenuGroupLabel data-flx="ui.action-menu.menu-group.title">
						{titleIcon}
						{title}
					</MenuGroupLabel>
				) : null}
				{validChildren}
			</MenuGroupPrimitive>
			<MenuSeparator data-flx="ui.action-menu.menu-group.menu-separator" />
		</>
	);
});
